import { useEffect, useState } from 'react'

/**
 * Whole seconds left until `expiresAt` (epoch ms), ticking once a second and
 * clamped at zero. `null` while there is no deadline.
 */
export function useCountdown(expiresAt: number | null): number | null {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (expiresAt === null) return
    const tick = () => setNow(Date.now())
    tick()
    const id = window.setInterval(tick, 1000)
    return () => window.clearInterval(id)
  }, [expiresAt])
  if (expiresAt === null) return null
  return Math.max(0, Math.ceil((expiresAt - now) / 1000))
}

/** `m:ss`, digits in the reader's own numerals. */
export function clockFormat(seconds: number, formatDigits: (n: number) => string): string {
  const minutes = Math.floor(seconds / 60)
  const rest = seconds % 60
  return `${formatDigits(minutes)}:${formatDigits(Math.floor(rest / 10))}${formatDigits(rest % 10)}`
}
